export const normalizePhone = (phone: string = '') => phone.replace(/[()\s-]/g, '');

export const formatPhoneNumber = (phone: string = '') => {
  const formattedPattern = /^\(\d{3}\) \d{3}-\d{2}-\d{2}$/;

  if (formattedPattern.test(phone)) {
    return phone;
  }

  return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6, 8)}-${phone.slice(8, 10)}`;
};

export const getFieldValue = (value: any): string => String(value ?? '');

export const paramsSerializer = (params: any) => {
  const qs = new URLSearchParams();

  function build(key: string, val: any) {
    if (Array.isArray(val)) {
      val.forEach(v => qs.append(`${key}[]`, String(v)));
    } else if (val !== null && typeof val === 'object') {
      Object.entries(val).forEach(([k, v]) => build(`${key}[${k}]`, v));
    } else {
      qs.append(key, String(val));
    }
  }

  Object.entries(params).forEach(([k, v]) => build(k, v));
  return qs.toString();
};
